import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useTenantRemoveMutation } from "@/v2-backoffice-client/tenant/remove/tenant.remove.mutation"

export type TenantRemoveMenuItemProps = Omit<ActionMenuItemProps, "onClick"> & {
  tenantId: number | null | undefined
  confirmDescription?: string
  onCompleted?(): void
}

function TenantRemoveMenuItem(props: TenantRemoveMenuItemProps) {
  const { tenantId, confirmDescription, onCompleted, ...menuItemProps } = props

  const [removeTenant, { loading, error }] = useTenantRemoveMutation({
    onCompleted,
  })

  return (
    <ActionMenu.ConfirmItem
      iconSrc="trash"
      variant="destructive"
      isLoading={loading}
      error={error}
      errorTitle="Failed to remove team"
      disabled={!tenantId}
      confirmTitle="Remove Team"
      confirmDescription={
        confirmDescription ?? "Are you sure you want to remove this team?"
      }
      confirmText="Remove"
      confirmVariant="destructive"
      onConfirm={async () => {
        if (!tenantId) return
        await removeTenant({ variables: { id: tenantId } })
      }}
      {...menuItemProps}
    >
      Remove Team
    </ActionMenu.ConfirmItem>
  )
}

export default TenantRemoveMenuItem
